/* eslint-disable  */
import React, { createContext, useState, ReactNode } from 'react';
import {
  IncomeInterface,
  OptionInterface,
} from '../../interface/CustomerInformationInterface';

interface IncomeContextInterface {
  incomeInformation: IncomeInterface;
  setIncomeInformation: React.Dispatch<React.SetStateAction<IncomeInterface>>;
  residenceDoc: string;
  setResidenceDoc: React.Dispatch<React.SetStateAction<string>>;
  fileSize: string;
  setFileSize: React.Dispatch<React.SetStateAction<string>>;
  fileType: string;
  setFileType: React.Dispatch<React.SetStateAction<string>>;
  showResidenceVerfDocument: boolean;
  setShowResidenceVerfDocument: React.Dispatch<React.SetStateAction<boolean>>;
  typeOfIncomeOptions: OptionInterface[];
  setTypeOfIncomeOptions: React.Dispatch<
    React.SetStateAction<OptionInterface[]>
  >;
  jobTypeOptions: OptionInterface[];
  setJobTypeOptions: React.Dispatch<React.SetStateAction<OptionInterface[]>>;
  incomeSave: boolean;
  setIncomeSave: React.Dispatch<React.SetStateAction<boolean>>;
  stgCustomerEmpId: string;
  setStgCustomerEmpId: React.Dispatch<React.SetStateAction<string>>;
  consentDate: string;
  setConsentDate: React.Dispatch<React.SetStateAction<string>>;

}

const IncomeContext = createContext<IncomeContextInterface | undefined>(
  undefined
);

const IncomeContextProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [incomeInformation, setIncomeInformation] = useState<IncomeInterface>({
    typeOfIncomeProof: '',
    companyName: '',
    joiningDate: '',
    netMonthlyIncome: '',
    jobPosition: '',
    jobType: '',
  });
  const [residenceDoc, setResidenceDoc] = useState<string>('');
  const [fileSize, setFileSize] = useState<string>('');
  const [fileType, setFileType] = useState<string>('');
  const [showResidenceVerfDocument, setShowResidenceVerfDocument] =
    useState<boolean>(false);
  const [typeOfIncomeOptions, setTypeOfIncomeOptions] = useState<OptionInterface[]>([]);
  const [jobTypeOptions, setJobTypeOptions] = useState<OptionInterface[]>([]);
  const [incomeSave, setIncomeSave] = useState<boolean>(false);
  const [stgCustomerEmpId, setStgCustomerEmpId] = useState<string>('');
  const [consentDate, setConsentDate] = useState<string>('');



  return (
    <IncomeContext.Provider
      value={{
        incomeInformation,
        setIncomeInformation,
        residenceDoc,
        setResidenceDoc,
        fileSize,
        setFileSize,
        fileType,
        setFileType,
        showResidenceVerfDocument,
        setShowResidenceVerfDocument,
        typeOfIncomeOptions,
        setTypeOfIncomeOptions,
        jobTypeOptions,
        setJobTypeOptions,
        incomeSave,
        setIncomeSave,
        stgCustomerEmpId, setStgCustomerEmpId,
        consentDate, setConsentDate

      }}
    >
      {props.children}
    </IncomeContext.Provider>
  );
};

export { IncomeContext, IncomeContextProvider };
